import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true,
  breaks: false,
})

// Convert help:// internal links to a data attribute so the viewer can intercept them
const defaultLinkOpen = md.renderer.rules.link_open || ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options))
md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  const hrefIndex = tokens[idx].attrIndex('href')
  if (hrefIndex >= 0) {
    const href = tokens[idx].attrs[hrefIndex][1]
    if (href.startsWith('help://')) {
      tokens[idx].attrs[hrefIndex][1] = '#'
      tokens[idx].attrSet('data-help-link', href.replace('help://', ''))
      tokens[idx].attrSet('class', 'help-internal-link')
    }
  }
  return defaultLinkOpen(tokens, idx, options, env, self)
}

// Render custom container directives: :::tip, :::note, :::warning
function containerPlugin(md) {
  const types = ['tip', 'note', 'warning', 'danger']
  const pattern = new RegExp(`^:::(${types.join('|')})\\s*(.*)$`)

  md.core.ruler.push('containers', (state) => {
    const tokens = state.tokens
    for (let i = 0; i < tokens.length; i++) {
      if (tokens[i].type !== 'inline') continue
      const m = tokens[i].content.match(pattern)
      if (m) {
        tokens[i].type = 'html_block'
        tokens[i].content = `<div class="doc-container doc-container--${m[1]}">${m[2] ? `<strong>${m[2]}</strong>` : ''}</div>`
      }
      if (tokens[i].content === ':::') {
        tokens[i].type = 'html_block'
        tokens[i].content = ''
      }
    }
  })
}

md.use(containerPlugin)

export function renderMarkdown(content) {
  return md.render(content)
}

export function parseFrontmatter(raw) {
  const fmRegex = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/
  const match = raw.match(fmRegex)
  if (!match) return { meta: {}, content: raw }

  const yamlBlock = match[1]
  const content = match[2]

  const meta = {}
  for (const line of yamlBlock.split('\n')) {
    const colonIdx = line.indexOf(':')
    if (colonIdx === -1) continue
    const key = line.slice(0, colonIdx).trim()
    const rawVal = line.slice(colonIdx + 1).trim()
    if (!key) continue

    // Arrays inline: [a, b]
    if (rawVal.startsWith('[') && rawVal.endsWith(']')) {
      meta[key] = rawVal.slice(1, -1).split(',').map(s => s.trim()).filter(Boolean)
    } else if (rawVal !== '') {
      meta[key] = rawVal
    }
  }

  // Handle multi-line array values (YAML list with leading dashes)
  // Simple pass: look for lines starting with "  - value" after a key
  const lines = yamlBlock.split('\n')
  let currentKey = null
  const arrayMap = {}
  for (const line of lines) {
    const kMatch = line.match(/^(\w[\w-]*):\s*$/)
    if (kMatch) { currentKey = kMatch[1]; arrayMap[currentKey] = []; continue }
    if (currentKey) {
      const itemMatch = line.match(/^\s+-\s+(.+)$/)
      if (itemMatch) { arrayMap[currentKey].push(itemMatch[1].trim()) }
      else if (line.trim() !== '') currentKey = null
    }
  }
  for (const [k, v] of Object.entries(arrayMap)) {
    if (v.length > 0) meta[k] = v
  }

  return { meta, content }
}
